export default "<h2 class=\"h6 text-primary\">Reportar un error</h2>\n<app-report-form [data]=\"data\" (sended)=\"sended($event)\"></app-report-form>\n"